'use strict';

exports.__esModule = true;

var _ServerApi2 = require('./ServerApi');

var _ServerApi3 = _interopRequireDefault(_ServerApi2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeoApi = function (_ServerApi) {
  _inherits(GeoApi, _ServerApi);

  function GeoApi() {
    _classCallCheck(this, GeoApi);

    return _possibleConstructorReturn(this, _ServerApi.apply(this, arguments));
  }

  GeoApi.prototype.getCities = function getCities(search, limit) {
    return _ServerApi.prototype.get.call(this, '/geo/city/?search=' + search + '&limit=' + limit);
  };

  GeoApi.prototype.getCountries = function getCountries() {
    return _ServerApi.prototype.get.call(this, '/geo/country/');
  };

  return GeoApi;
}(_ServerApi3.default);

exports.default = new GeoApi();
module.exports = exports['default'];